const typographyMarkerClasses = {
  regular: 'heading-regular', r: 'heading-regular',
  thin: 'heading-thin', t: 'heading-thin',
  italic: 'heading-italic', i: 'heading-italic',
  'thin-italic': 'heading-thin-italic', ti: 'heading-thin-italic',
  medium: 'heading-medium', m: 'heading-medium',
  bold: 'heading-bold', b: 'heading-bold'
};

const typographyMarkerPattern = /\[(regular|thin|italic|thin-italic|medium|bold|r|t|i|ti|m|b)\]([\s\S]*?)\[\/\1\]/gi;
const typographyHeadingSelector = 'h1, h2, h3, h4, h5, h6, .h0, .h1, .h2, .h3, .h4, .h5, .h6, .subheading';

function formatTypographyHeading(heading) {
  const walker = document.createTreeWalker(heading, NodeFilter.SHOW_TEXT);
  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);

  textNodes.forEach((textNode) => {
    const text = textNode.nodeValue;
    typographyMarkerPattern.lastIndex = 0;
    if (!typographyMarkerPattern.test(text)) return;

    typographyMarkerPattern.lastIndex = 0;
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    let match;

    while ((match = typographyMarkerPattern.exec(text)) !== null) {
      fragment.append(text.slice(lastIndex, match.index));
      const span = document.createElement('span');
      span.className = typographyMarkerClasses[match[1].toLowerCase()];
      span.textContent = match[2];
      fragment.append(span);
      lastIndex = match.index + match[0].length;
    }

    fragment.append(text.slice(lastIndex));
    textNode.replaceWith(fragment);
  });
}

function enforceModelsThinItalic(root = document) {
  root.querySelectorAll?.('.models-heading .heading-thin-italic').forEach((span) => {
    span.style.setProperty('display', 'inline-block', 'important');
    span.style.setProperty('font-family', '"Helvetica Neue Hairline", "Helvetica Neue Custom", sans-serif', 'important');
    span.style.setProperty('font-weight', '100', 'important');
    span.style.setProperty('font-style', 'normal', 'important');
    span.style.setProperty('font-synthesis', 'none', 'important');
    span.style.setProperty('transform', 'skewX(-12deg)', 'important');
    span.style.setProperty('transform-origin', 'center', 'important');
  });
}

function applyTypographyMarkers(root = document) {
  if (root.matches?.(typographyHeadingSelector)) formatTypographyHeading(root);
  root.querySelectorAll?.(typographyHeadingSelector).forEach(formatTypographyHeading);
  enforceModelsThinItalic(root);
}

applyTypographyMarkers();
new MutationObserver((mutations) => {
  mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) applyTypographyMarkers(node);
  }));
}).observe(document.documentElement, { childList: true, subtree: true });
